'use client';

import {
    useBrandsTableController,
    type UseBrandsTableControllerArgs,
} from '@/components/brands-table/use-brands-table-controller';
import { BrandsTableView } from '@/components/brands-table/BrandsTableView';

type BrandsTableProps = UseBrandsTableControllerArgs;

const BrandsTable = (props: BrandsTableProps) => {
    const controller = useBrandsTableController(props);

    return <BrandsTableView {...controller} />;
};

export default BrandsTable;
